export const SUGGESTION_COLOR = "#E5F0FF";
export const SELECTION_COLOR = "#006AFF";

export type CalendarEvent = {
  id?: string;
  title?: string;
  start?: Date | null;
  end?: Date | null;
  allDay?: boolean;
};

export type PersistableCalendarEvent = Omit<CalendarEvent, "start" | "end"> & {
  start?: string;
  end?: string;
};
